export var MessageTypes = /* @__PURE__ */ ((MessageTypes2) => {
  MessageTypes2["NEGATIVE"] = "negative";
  MessageTypes2["POSITIVE"] = "positive";
  MessageTypes2["NEUTRAL"] = "neutral";
  MessageTypes2["INFO"] = "info";
  MessageTypes2["WARNING"] = "warning";
  return MessageTypes2;
})(MessageTypes || {});
export var ReliabilityActions = /* @__PURE__ */ ((ReliabilityActions2) => {
  ReliabilityActions2["REPORT"] = "report";
  ReliabilityActions2["CHARGE"] = "charge";
  ReliabilityActions2["RATING"] = "rating";
  return ReliabilityActions2;
})(ReliabilityActions || {});
export var DrawerTabs = /* @__PURE__ */ ((DrawerTabs2) => {
  DrawerTabs2["INFO"] = "info";
  DrawerTabs2["CONNECTORS"] = "connectors";
  DrawerTabs2["REVIEWS"] = "reviews";
  DrawerTabs2["ASSISTANCE"] = "assistance";
  return DrawerTabs2;
})(DrawerTabs || {});
export var DrawerView = /* @__PURE__ */ ((DrawerView2) => {
  DrawerView2["Preview"] = "preview";
  DrawerView2["Prices"] = "prices";
  DrawerView2["Simulator"] = "simulator";
  DrawerView2["VehicleSelection"] = "vehicle-selection";
  DrawerView2["ConnectorSelection"] = "connector-selection";
  DrawerView2["Filters"] = "filters";
  DrawerView2["RoutePlanner"] = "route-planner";
  return DrawerView2;
})(DrawerView || {});
export var VehicleManagementView = /* @__PURE__ */ ((VehicleManagementView2) => {
  VehicleManagementView2["LIST"] = "list";
  VehicleManagementView2["FORM"] = "form";
  VehicleManagementView2["DELETE"] = "delete";
  return VehicleManagementView2;
})(VehicleManagementView || {});
